import { forwardRef } from 'react';
import type { SelectHTMLAttributes } from 'react';
import { cn } from '../../lib/utils/cn';

type Props = SelectHTMLAttributes<HTMLSelectElement> & {
  error?: boolean;
};

const Select = forwardRef<HTMLSelectElement, Props>(({ className, error, ...props }, ref) => {
  return (
    <select
      ref={ref}
      className={cn(
        'w-full rounded-lg border bg-white px-4 py-2.5 focus:outline-none focus:ring-2 disabled:bg-gray-50 disabled:cursor-not-allowed',
        error
          ? 'border-red-300 focus:ring-red-500'
          : 'border-gray-300 focus:ring-green-500 focus:border-green-500',
        className
      )}
      {...props}
    />
  );
});

Select.displayName = 'Select';

export default Select;
